/**
 * The file name in a Content-Disposition response header: the UTF-8 form (`filename*=UTF-8''…`) if there is one,
 * else the plain quoted one. Null when there is no header or no name in it.
 *
 * Its own module, with no imports, so it can be tested without a browser: apiClient touches `window` at load.
 *
 * ⚠️ A page on another origin can read this header only if the API lists it in `Access-Control-Expose-Headers`
 * (`exposedHeaders` in the API's `enableCors`). Without that the header is simply absent and this returns null, so
 * a caller keeps a sensible name of its own for that case.
 */
export function fileNameFromDisposition(header: string | null | undefined): string | null {
  if (!header) return null;
  const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (star) {
    try { return decodeURIComponent(star[1].trim()); } catch { /* fall through to the plain form */ }
  }
  const plain = /filename\s*=\s*"([^"]*)"/i.exec(header) ?? /filename\s*=\s*([^;]+)/i.exec(header);
  return plain ? plain[1].trim() : null;
}
